import { z } from 'zod';

export enum EventName {
  ViewContent = 'ViewContent',
  Search = 'Search',
  AddToCart = 'AddToCart',
  AddToWishlist = 'AddToWishlist',
  InitiateCheckout = 'InitiateCheckout',
  AddPaymentInfo = 'AddPaymentInfo',
  Purchase = 'Purchase',
  Lead = 'Lead',
  Other = 'Other',
  CompleteRegistration = 'CompleteRegistration',
  Contact = 'Contact',
  CustomizeProduct = 'CustomizeProduct',
  Donate = 'Donate',
  FindLocation = 'FindLocation',
  Schedule = 'Schedule',
  StartTrial = 'StartTrial',
  SubmitApplication = 'SubmitApplication',
  Subscribe = 'Subscribe',
}

// for whatever reason, we cannot use required or invalid error codes, so we need to make our own mapping
const errorMap: z.ZodErrorMap = (err, ctx) => {
  return { message: 'Invalid event name.' };
};

export const eventNameSchema = z.nativeEnum(EventName, { errorMap });
